<template>
  <div id="app">
    <dash-board/>
  </div>
</template>

<script>
import DashBoard from './components/DashBoard'

export default {
  name: 'App',
  components: {
    DashBoard
  }
}
</script>
<style>
  .main-panel{
    background-color: #fbfbfc;

  }
  body{
    background-color: #fbfbfc;
  }
</style>